<script>
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, email } from '@vuelidate/validators';
export default {
  components: {
    NextButton,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    displayName: {
      type: String,
      default: '',
    },
    emailEnabled: {
      type: Boolean,
      default: false,
    },
    nCrmTemsilciId: {
      type: Number,
      default: null,
    },
    nSantralId: {
      type: Number,
      default: null,
    },
    cSantralDahili: {
      type: String,
      default: '',
    },
  },
  emits: ['updateUser'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      userName: this.name,
      userDisplayName: this.displayName,
      userEmail: this.email,
      userNCrmTemsilciId: this.nCrmTemsilciId,
      userNSantralId: this.nSantralId,
      userCSantralDahili: this.cSantralDahili,
      inputStyles: {
        borderRadius: '0.75rem',
        padding: '0.375rem 0.75rem',
        fontSize: '0.875rem',
        marginBottom: '0.125rem',
      },
    };
  },
  validations: {
    userName: {
      required,
      minLength: minLength(1),
    },
    userDisplayName: {},
    userEmail: {
      required,
      email,
    },
  },
  watch: {
    name: {
      handler(value) {
        this.userName = value;
      },
      immediate: true,
    },
    displayName: {
      handler(value) {
        this.userDisplayName = value;
      },
      immediate: true,
    },
    email: {
      handler(value) {
        this.userEmail = value;
      },
      immediate: true,
    },
    nCrmTemsilciId: {
      handler(value) {
        this.userNCrmTemsilciId = value;
      },
      immediate: true,
    },
    nSantralId: {
      handler(value) {
        this.userNSantralId = value;
      },
      immediate: true,
    },
    cSantralDahili: {
      handler(value) {
        this.userCSantralDahili = value;
      },
      immediate: true,
    },
  },
  methods: {
    async updateUser() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        useAlert(this.$t('PROFILE_SETTINGS.FORM.ERROR'));
        return;
      }
      this.$emit('updateUser', {
        name: this.userName,
        displayName: this.userDisplayName,
        email: this.userEmail,
        n_crm_temsilci_id: this.userNCrmTemsilciId,
        n_santral_id: this.userNSantralId,
        c_santral_dahili: this.userCSantralDahili,
      });
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="updateUser('profile')">
    <woot-input
      v-model="userName"
      :styles="inputStyles"
      :class="{ error: v$.userName.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.NAME.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.NAME.PLACEHOLDER')"
      :error="`${
        v$.userName.$error ? $t('PROFILE_SETTINGS.FORM.NAME.ERROR') : ''
      }`"
      @input="v$.userName.$touch"
      @blur="v$.userName.$touch"
    />
    <woot-input
      v-model="userDisplayName"
      :styles="inputStyles"
      :class="{ error: v$.userDisplayName.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.PLACEHOLDER')"
      :error="`${
        v$.userDisplayName.$error
          ? $t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.ERROR')
          : ''
      }`"
      @input="v$.userDisplayName.$touch"
      @blur="v$.userDisplayName.$touch"
    />
    <woot-input
      v-if="emailEnabled"
      v-model="userEmail"
      :styles="inputStyles"
      :class="{ error: v$.userEmail.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.EMAIL.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.EMAIL.PLACEHOLDER')"
      :error="`${
        v$.userEmail.$error ? $t('PROFILE_SETTINGS.FORM.EMAIL.ERROR') : ''
      }`"
      @input="v$.userEmail.$touch"
      @blur="v$.userEmail.$touch"
    />

    <!-- CRM ve Santral Bilgileri -->
    <woot-input
      v-model.number="userNCrmTemsilciId"
      :styles="inputStyles"
      type="number"
      :label="$t('PROFILE_SETTINGS.FORM.N_CRM_TEMSILCI_ID.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.N_CRM_TEMSILCI_ID.PLACEHOLDER')"
    />
    <woot-input
      v-model.number="userNSantralId"
      :styles="inputStyles"
      type="number"
      :label="$t('PROFILE_SETTINGS.FORM.N_SANTRAL_ID.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.N_SANTRAL_ID.PLACEHOLDER')"
    />
    <woot-input
      v-model="userCSantralDahili"
      :styles="inputStyles"
      :label="$t('PROFILE_SETTINGS.FORM.C_SANTRAL_DAHILI.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.C_SANTRAL_DAHILI.PLACEHOLDER')"
    />

    <div>
      <NextButton type="submit" :label="$t('PROFILE_SETTINGS.BTN_TEXT')" />
    </div>
  </form>
</template>
